webpackJsonp([1],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(50);
	
	var _redux = __webpack_require__(125);
	
	var _reduxThunk = __webpack_require__(294);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(293);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reactRedux = __webpack_require__(51);
	
	var _actions = __webpack_require__(78);
	
	var _reducers = __webpack_require__(143);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _componentsAppApp = __webpack_require__(135);
	
	var _componentsAppApp2 = _interopRequireDefault(_componentsAppApp);
	
	var mountNode = document.getElementById('root');
	
	var middleware = [_reduxThunk2['default']];
	
	if (false) {
	    middleware.push(_reduxLogger2['default']());
	}
	
	var store = _redux.createStore(_reducers2['default'], _redux.applyMiddleware.apply(undefined, middleware));
	
	_reactDom.render({
	    $$typeof: _typeofReactElement,
	    type: _reactRedux.Provider,
	    key: null,
	    ref: null,
	    props: _defaultProps(_reactRedux.Provider.defaultProps, {
	        children: {
	            $$typeof: _typeofReactElement,
	            type: _componentsAppApp2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsAppApp2['default'].defaultProps, {}),
	            _owner: null
	        },
	        store: store
	    }),
	    _owner: null
	}, mountNode);
	
	store.dispatch(_actions.loadItinerary());

/***/ },

/***/ 78:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(88);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _dataItineraryJson = __webpack_require__(91);
	
	var _dataItineraryJson2 = _interopRequireDefault(_dataItineraryJson);
	
	var GET_ITINERARY = 'GET_ITINERARY';
	exports.GET_ITINERARY = GET_ITINERARY;
	var SET_ITINERARY = 'SET_ITINERARY';
	
	exports.SET_ITINERARY = SET_ITINERARY;
	var getItinerary = function getItinerary() {
	    return {
	        type: GET_ITINERARY
	    };
	};
	
	var setItinerary = function setItinerary(itinerary) {
	    return {
	        type: SET_ITINERARY,
	        itinerary: _immutable2['default'].fromJS(itinerary)
	    };
	};
	
	var loadItinerary = function loadItinerary() {
	    return function (dispatch) {
	        dispatch(getItinerary());
	
	        setTimeout(function () {
	            dispatch(setItinerary(_dataItineraryJson2['default']));
	        }, 100);
	    };
	};
	exports.loadItinerary = loadItinerary;

/***/ },

/***/ 79:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = cleanHtml;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _sanitizeHtml = __webpack_require__(302);
	
	var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);
	
	function cleanHtml(theUncleanHTMLString) {
	    return _sanitizeHtml2['default'](theUncleanHTMLString, {
	        allowedAttributes: {
	            '*': ['href', 'align', 'alt', 'title', 'class']
	        }
	    });
	}
	
	;
	module.exports = exports['default'];

/***/ },

/***/ 82:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timeline-list-item":"_247s5","timeline-list-item-header":"_2iTF1","timeline-list-item-content-center":"_2hgIz","timeline-list-item-content-detail":"_2JTH2","timeline-list-item-content-left":"_14qTm","timeline-list-item-content-right":"_1ThsZ"};

/***/ },

/***/ 83:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2aLrf"};

/***/ },

/***/ 84:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"panel":"_1_5KL","panel-header":"HHiAY","panel-header-light":"_1DPqd"};

/***/ },

/***/ 91:
/***/ function(module, exports) {

	module.exports = {
		"title": "Chicago <i class=\"fa fa-arrow-right\"></i> Sydney <i class=\"fa fa-arrow-right\"></i> New Zealand",
		"start": "Chicago",
		"destinations": {
			"Chicago": {
				"lat": 41.786776,
				"lng": -87.752188
			},
			"San Francisco": {
				"lat": 37.621313,
				"lng": -122.378955
			},
			"Sydney": {
				"lat": -33.86882,
				"lng": 151.209296
			},
			"Christchurch": {
				"lat": -43.532054,
				"lng": 172.636225
			},
			"Lake Tekapo": {
				"lat": -44.004674,
				"lng": 170.477121
			},
			"Queenstown": {
				"lat": -45.031162,
				"lng": 168.662644
			},
			"Wanaka": {
				"lat": -44.703181,
				"lng": 169.132098
			},
			"Franz Josef": {
				"lat": -43.387329,
				"lng": 170.183288
			},
			"Auckland": {
				"lat": -36.84846,
				"lng": 174.763332
			},
			"Bay of Islands": {
				"lat": -35.18437,
				"lng": 174.164616
			},
			"Orewa": {
				"lat": -36.581552,
				"lng": 174.689952
			},
			"Waiwera": {
				"lat": -36.543368,
				"lng": 174.703911
			},
			"Honolulu": {
				"lat": 21.306944,
				"lng": -157.858333
			}
		},
		"items": [
			{
				"date": "February 11, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"MDW",
					"SFO"
				],
				"destinations": [
					"Chicago",
					"San Francisco"
				],
				"lodging": "Aloft San Francisco Airport",
				"activities": [
					"Golden Gate Bridge",
					"Sutro Baths"
				]
			},
			{
				"date": "February 12, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"SFO",
					"AKL",
					"SYD"
				],
				"destinations": [
					"San Francisco",
					"Auckland",
					"Sydney"
				],
				"lodging": "Air New Zealand",
				"activities": [
					"Golden Gate Park",
					"San Francisco Botanical Garden"
				]
			},
			{
				"date": "February 13, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"SFO",
					"AKL",
					"SYD"
				]
			},
			{
				"date": "February 14, 2017",
				"destinations": [
					"Sydney"
				],
				"lodging": "Sydney Hostel",
				"activities": [
					"Opera House",
					"Downtown Sydney"
				]
			},
			{
				"date": "February 15, 2017",
				"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
				"destinations": [
					"Sydney"
				],
				"lodging": "Sydney Hostel",
				"activities": [
					"Blue Mountains Day Trip",
					"Katoomba Scenic World",
					"Jamison Valley/Three Sisters rock formations",
					"Echo Point",
					"Featherdale Wildlife Park",
					"Parramatta River cruise"
				]
			},
			{
				"date": "February 16, 2017",
				"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
				"destinations": [
					"Sydney"
				],
				"lodging": "Sydney Hostel",
				"activities": [
					"Sydney City Tour",
					"Bondi Beach",
					"Sydney Harbour Luncheon Cruise"
				]
			},
			{
				"date": "February 17, 2017",
				"dayType": "<i class=\"fa fa-users\"></i> Travel Day",
				"airports": [
					"SYD",
					"CHC"
				],
				"destinations": [
					"Sydney",
					"Christchurch"
				],
				"lodging": "Haka Lodge Christchurch",
				"activities": [
					"Sydney Bridge Climb"
				]
			},
			{
				"date": "February 18, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Christchurch",
					"Lake Tekapo"
				],
				"lodging": "Lake Tekapo Hotel",
				"activities": [
					"Downtown Christchurch",
					"Lake Tekapo"
				]
			},
			{
				"date": "February 19, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Lake Tekapo",
					"Queenstown"
				],
				"lodging": "Haka Lodge Queenstown",
				"activities": [
					"Wine Tasting in Otago",
					"Salmon Farms",
					"Queenstown Gondola Ride"
				]
			},
			{
				"date": "February 20, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Queenstown"
				],
				"lodging": "Haka Lodge Queenstown",
				"activities": [
					"Milford Sound Trip"
				]
			},
			{
				"date": "February 21, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Queenstown",
					"Wanaka"
				],
				"lodging": "Wanaka Hotel",
				"activities": [
					"Arrowtown",
					"Cardrona - New Zealand's Oldest Pub",
					"Wanaka"
				]
			},
			{
				"date": "February 22, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Wanaka",
					"Franz Josef"
				],
				"lodging": "Franz Josef Hotel",
				"activities": [
					"Mt. Iron Hike",
					"Random Road Trip Stops"
				]
			},
			{
				"date": "February 23, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Franz Josef"
				],
				"lodging": "Franz Josef Hotel",
				"activities": [
					"Glacier Helicopter Hike",
					"Farewell Party"
				]
			},
			{
				"date": "February 24, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Haka Tours",
				"destinations": [
					"Franz Josef",
					"Christchurch"
				],
				"lodging": "Haka Lodge Christchurch",
				"activities": [
					"Hokitika Greenstone Factory",
					"National Kiwi Centre (time permitting)",
					"Tranz Alpine Train Crossing"
				]
			},
			{
				"date": "February 25, 2017",
				"dayType": "<i class=\"fa fa-birthday-cake\"></i> Birthday",
				"destinations": [
					"Christchurch"
				],
				"lodging": "Christchurch Hotel",
				"activities": [
					"Downtown Christchurch",
					"Relax"
				]
			},
			{
				"date": "February 26, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"CHC",
					"AKL"
				],
				"destinations": [
					"Christchurch",
					"Auckland"
				],
				"lodging": "Haka Lodge Auckland",
				"activities": [
					"Downtown Auckland"
				]
			},
			{
				"date": "February 27, 2017",
				"dayType": "<i class=\"fa fa-users\"></i> Group Tour",
				"destinations": [
					"Auckland"
				],
				"lodging": "Haka Lodge Auckland",
				"activities": [
					"Hobbiton Road Trip"
				]
			},
			{
				"date": "February 28, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
				"destinations": [
					"Auckland",
					"Bay of Islands"
				],
				"lodging": "Campsite",
				"activities": [
					"Beach stop",
					"Paihia",
					"Mangrove walk or bike to Thundering Falls"
				]
			},
			{
				"date": "March 1, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
				"destinations": [
					"Bay of Islands"
				],
				"lodging": "Campsite",
				"activities": [
					"Swimming with Dolphins",
					"Sailing the Bay of Islands"
				]
			},
			{
				"date": "March 2, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
				"destinations": [
					"Bay of Islands",
					"Orewa"
				],
				"lodging": "Campsite",
				"activities": [
					"Sand Boarding Opononi",
					"Hot Pools and Slides"
				]
			},
			{
				"date": "March 3, 2017",
				"dayType": "<i class=\"fa fa-bus\"></i> Flying Kiwi Tours",
				"destinations": [
					"Waiwera",
					"Auckland"
				],
				"lodging": "Haka Lodge Auckland",
				"activities": [
					"Downtown Auckland",
					"Relax"
				]
			},
			{
				"date": "March 4, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"AKL",
					"HNL",
					"SFO"
				],
				"destinations": [
					"Auckland",
					"Honolulu",
					"San Francisco"
				],
				"lodging": "Aloft San Francisco",
				"activities": [
					"Recovery"
				]
			},
			{
				"date": "March 5, 2017",
				"dayType": "<i class=\"fa fa-plane\"></i> Travel Day",
				"airports": [
					"SFO",
					"MDW"
				],
				"destinations": [
					"San Francisco",
					"Chicago"
				],
				"lodging": "Home",
				"activities": [
					"Recovery"
				]
			}
		]
	};

/***/ },

/***/ 135:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesStylesCss = __webpack_require__(163);
	
	var _stylesStylesCss2 = _interopRequireDefault(_stylesStylesCss);
	
	var _stylesCss = __webpack_require__(158);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var _componentsMapMap = __webpack_require__(138);
	
	var _componentsMapMap2 = _interopRequireDefault(_componentsMapMap);
	
	var _componentsItineraryItinerary = __webpack_require__(137);
	
	var _componentsItineraryItinerary2 = _interopRequireDefault(_componentsItineraryItinerary);
	
	var _ref = {
	    $$typeof: _typeofReactElement,
	    type: _componentsItineraryItinerary2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_componentsItineraryItinerary2['default'].defaultProps, {}),
	    _owner: null
	};
	var _ref2 = {
	    $$typeof: _typeofReactElement,
	    type: _componentsMapMap2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_componentsMapMap2['default'].defaultProps, {}),
	    _owner: null
	};
	
	var App = (function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    App.prototype.render = function render() {
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'main',
	            key: null,
	            ref: null,
	            props: {
	                children: [_ref, _ref2],
	                className: _stylesCss2['default'].container
	            },
	            _owner: null
	        };
	    };
	
	    return App;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 136:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsJanitor = __webpack_require__(79);
	
	var _utilsJanitor2 = _interopRequireDefault(_utilsJanitor);
	
	var _stylesCss = __webpack_require__(159);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var Header = (function (_React$Component) {
	    _inherits(Header, _React$Component);
	
	    function Header() {
	        _classCallCheck(this, Header);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    Header.prototype.render = function render() {
	        var self = this,
	            title = self.props.title || '';
	
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'header',
	            key: null,
	            ref: null,
	            props: {
	                children: {
	                    $$typeof: _typeofReactElement,
	                    type: 'h1',
	                    key: null,
	                    ref: null,
	                    props: {
	                        dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](title) }
	                    },
	                    _owner: null
	                },
	                className: _stylesCss2['default']['app-header']
	            },
	            _owner: null
	        };
	    };
	
	    return Header;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ },

/***/ 137:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stylesCss = __webpack_require__(160);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var _containersHeaderHeader = __webpack_require__(141);
	
	var _containersHeaderHeader2 = _interopRequireDefault(_containersHeaderHeader);
	
	var _containersTimelineTimeline = __webpack_require__(142);
	
	var _containersTimelineTimeline2 = _interopRequireDefault(_containersTimelineTimeline);
	
	var _ref = {
	    $$typeof: _typeofReactElement,
	    type: _containersHeaderHeader2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_containersHeaderHeader2['default'].defaultProps, {}),
	    _owner: null
	};
	var _ref2 = {
	    $$typeof: _typeofReactElement,
	    type: _containersTimelineTimeline2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_containersTimelineTimeline2['default'].defaultProps, {}),
	    _owner: null
	};
	
	var App = (function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    App.prototype.render = function render() {
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	                children: [_ref, _ref2],
	                className: _stylesCss2['default'].container
	            },
	            _owner: null
	        };
	    };
	
	    return App;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 138:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGoogleMaps = __webpack_require__(215);
	
	var _mapStylesJson = __webpack_require__(180);
	
	var _mapStylesJson2 = _interopRequireDefault(_mapStylesJson);
	
	var _dataItineraryJson = __webpack_require__(91);
	
	var _dataItineraryJson2 = _interopRequireDefault(_dataItineraryJson);
	
	var _stylesCss = __webpack_require__(161);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var App = (function (_React$Component) {
	    _inherits(App, _React$Component);
	
	    function App() {
	        _classCallCheck(this, App);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    App.prototype.render = function render() {
	        var markers, polylinePath;
	
	        markers = [{
	            $$typeof: _typeofReactElement,
	            type: _reactGoogleMaps.Marker,
	            key: 'start',
	            ref: null,
	            props: _defaultProps(_reactGoogleMaps.Marker.defaultProps, {
	                children: [],
	                position: _dataItineraryJson2['default'].destinations[_dataItineraryJson2['default'].start],
	                title: _dataItineraryJson2['default'].start,
	                defaultAnimation: 2
	            }),
	            _owner: null
	        }];
	
	        polylinePath = [_dataItineraryJson2['default'].destinations[_dataItineraryJson2['default'].start]];
	
	        _dataItineraryJson2['default'].items.filter(function (day) {
	            return day && day.destinations && day.destinations.length;
	        }).reduce(function (prev, curr) {
	            console.log(prev);
	            console.log(curr);
	            curr.destinations.forEach(function (destination) {
	                if (!prev.length || prev[prev.length - 1] !== destination) {
	                    prev.push(destination);
	                }
	            });
	
	            return prev;
	        }, []).forEach(function (destination, index) {
	            markers.push({
	                $$typeof: _typeofReactElement,
	                type: _reactGoogleMaps.Marker,
	                key: index,
	                ref: null,
	                props: _defaultProps(_reactGoogleMaps.Marker.defaultProps, {
	                    children: [],
	                    position: _dataItineraryJson2['default'].destinations[destination],
	                    title: destination,
	                    defaultAnimation: 2
	                }),
	                _owner: null
	            });
	
	            polylinePath.push(_dataItineraryJson2['default'].destinations[destination]);
	        });
	
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	                children: {
	                    $$typeof: _typeofReactElement,
	                    type: _reactGoogleMaps.GoogleMapLoader,
	                    key: null,
	                    ref: null,
	                    props: _defaultProps(_reactGoogleMaps.GoogleMapLoader.defaultProps, {
	                        containerElement: {
	                            $$typeof: _typeofReactElement,
	                            type: 'div',
	                            key: null,
	                            ref: null,
	                            props: {
	                                className: _stylesCss2['default'].map
	                            },
	                            _owner: null
	                        },
	                        googleMapElement: _react2['default'].createElement(
	                            _reactGoogleMaps.GoogleMap,
	                            {
	                                ref: function (map) {
	                                    return console.log(map);
	                                },
	                                defaultZoom: 3,
	                                defaultCenter: { lat: 21.306944, lng: -157.858333 },
	                                defaultOptions: {
	                                    styles: _mapStylesJson2['default']
	                                } },
	                            {
	                                $$typeof: _typeofReactElement,
	                                type: _reactGoogleMaps.Polyline,
	                                key: null,
	                                ref: null,
	                                props: _defaultProps(_reactGoogleMaps.Polyline.defaultProps, {
	                                    geodesic: true,
	                                    options: {
	                                        strokeColor: '#FF0000',
	                                        strokeOpacity: 1,
	                                        strokeWeight: 2
	                                    },
	                                    path: polylinePath
	                                }),
	                                _owner: null
	                            },
	                            markers
	                        )
	                    }),
	                    _owner: null
	                },
	                className: _stylesCss2['default'].container
	            },
	            _owner: null
	        };
	    };
	
	    return App;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = App;
	module.exports = exports['default'];

/***/ },

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsJanitor = __webpack_require__(79);
	
	var _utilsJanitor2 = _interopRequireDefault(_utilsJanitor);
	
	var _stylesContainerCss = __webpack_require__(83);
	
	var _stylesContainerCss2 = _interopRequireDefault(_stylesContainerCss);
	
	var _stylesPanelCss = __webpack_require__(84);
	
	var _stylesPanelCss2 = _interopRequireDefault(_stylesPanelCss);
	
	var _stylesCss = __webpack_require__(82);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var _ref = {
	    $$typeof: _typeofReactElement,
	    type: 'i',
	    key: null,
	    ref: null,
	    props: {
	        className: 'fa fa-bed'
	    },
	    _owner: null
	};
	
	var TimelineItem = (function (_React$Component) {
	    _inherits(TimelineItem, _React$Component);
	
	    function TimelineItem() {
	        _classCallCheck(this, TimelineItem);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    TimelineItem.prototype.render = function render() {
	        var self = this,
	            detail = self.props.detail,
	            date,
	            dayType,
	            airports,
	            destinations,
	            lodging,
	            activities,
	            leftPanel,
	            rightPanel;
	
	        if (detail.get('date')) {
	            date = {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                    className: _stylesCss2['default']['timeline-list-item-header'],
	                    dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](detail.get('date')) }
	                },
	                _owner: null
	            };
	        }
	
	        if (detail.get('dayType')) {
	            dayType = {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                    className: _stylesCss2['default']['timeline-list-item-content-center'],
	                    dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](detail.get('dayType')) }
	                },
	                _owner: null
	            };
	        }
	
	        if (detail.get('airports') && detail.get('airports').size) {
	            airports = {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                    className: _stylesCss2['default']['timeline-list-item-content-center'],
	                    dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](detail.get('airports').join(' <i class="fa fa-arrow-circle-o-right"></i> ')) }
	                },
	                _owner: null
	            };
	        }
	
	        if (detail.get('destinations') && detail.get('destinations').size) {
	            destinations = {
	                $$typeof: _typeofReactElement,
	                type: 'header',
	                key: null,
	                ref: null,
	                props: {
	                    className: _stylesPanelCss2['default']['panel-header'],
	                    dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](detail.get('destinations').join(' <i class="fa fa-arrow-circle-o-right"></i> ')) }
	                },
	                _owner: null
	            };
	        }
	
	        if (detail.get('lodging')) {
	            lodging = {
	                $$typeof: _typeofReactElement,
	                type: 'p',
	                key: null,
	                ref: null,
	                props: {
	                    children: [_ref, ' ', detail.get('lodging')]
	                },
	                _owner: null
	            };
	        }
	
	        if (detail.get('activities') && detail.get('activities').size) {
	            activities = detail.get('activities').map(function (activity, key) {
	                return {
	                    $$typeof: _typeofReactElement,
	                    type: 'li',
	                    key: key,
	                    ref: null,
	                    props: {
	                        dangerouslySetInnerHTML: { __html: _utilsJanitor2['default'](activity) }
	                    },
	                    _owner: null
	                };
	            });
	        }
	
	        if (destinations || lodging) {
	            leftPanel = {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                    children: [destinations, lodging],
	                    className: _classnames2['default'](_stylesPanelCss2['default'].panel, _stylesCss2['default']['timeline-list-item-content-left'])
	                },
	                _owner: null
	            };
	        }
	
	        if (activities) {
	            rightPanel = {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                    children: {
	                        $$typeof: _typeofReactElement,
	                        type: 'ul',
	                        key: null,
	                        ref: null,
	                        props: {
	                            children: activities
	                        },
	                        _owner: null
	                    },
	                    className: _classnames2['default'](_stylesPanelCss2['default'].panel, _stylesCss2['default']['timeline-list-item-content-right'])
	                },
	                _owner: null
	            };
	        }
	
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	                children: [date, dayType, airports, leftPanel, rightPanel],
	                className: _stylesCss2['default']['timeline-list-item']
	            },
	            _owner: null
	        };
	    };
	
	    return TimelineItem;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = TimelineItem;
	module.exports = exports['default'];

/***/ },

/***/ 140:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(80);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _componentsTimelineItemTimelineItem = __webpack_require__(139);
	
	var _componentsTimelineItemTimelineItem2 = _interopRequireDefault(_componentsTimelineItemTimelineItem);
	
	var _stylesContainerCss = __webpack_require__(83);
	
	var _stylesContainerCss2 = _interopRequireDefault(_stylesContainerCss);
	
	var _stylesPanelCss = __webpack_require__(84);
	
	var _stylesPanelCss2 = _interopRequireDefault(_stylesPanelCss);
	
	var _componentsTimelineItemStylesCss = __webpack_require__(82);
	
	var _componentsTimelineItemStylesCss2 = _interopRequireDefault(_componentsTimelineItemStylesCss);
	
	var _stylesCss = __webpack_require__(162);
	
	var _stylesCss2 = _interopRequireDefault(_stylesCss);
	
	var Timeline = (function (_React$Component) {
	    _inherits(Timeline, _React$Component);
	
	    function Timeline() {
	        _classCallCheck(this, Timeline);
	
	        _React$Component.apply(this, arguments);
	    }
	
	    Timeline.prototype.render = function render() {
	        var self = this,
	            items = self.props.items;
	
	        return {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	                children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'div',
	                    key: null,
	                    ref: null,
	                    props: {
	                        className: _stylesCss2['default']['timeline-vertical-line']
	                    },
	                    _owner: null
	                }, {
	                    $$typeof: _typeofReactElement,
	                    type: 'div',
	                    key: null,
	                    ref: null,
	                    props: {
	                        children: [{
	                            $$typeof: _typeofReactElement,
	                            type: 'div',
	                            key: null,
	                            ref: null,
	                            props: {
	                                children: [{
	                                    $$typeof: _typeofReactElement,
	                                    type: 'div',
	                                    key: null,
	                                    ref: null,
	                                    props: {
	                                        children: {
	                                            $$typeof: _typeofReactElement,
	                                            type: 'header',
	                                            key: null,
	                                            ref: null,
	                                            props: {
	                                                children: 'Location',
	                                                className: _classnames2['default'](_stylesPanelCss2['default']['panel-header'], _stylesPanelCss2['default']['panel-header-light'])
	                                            },
	                                            _owner: null
	                                        },
	                                        className: _classnames2['default'](_stylesPanelCss2['default'].panel, _componentsTimelineItemStylesCss2['default']['timeline-list-item-content-left'])
	                                    },
	                                    _owner: null
	                                }, {
	                                    $$typeof: _typeofReactElement,
	                                    type: 'div',
	                                    key: null,
	                                    ref: null,
	                                    props: {
	                                        children: {
	                                            $$typeof: _typeofReactElement,
	                                            type: 'header',
	                                            key: null,
	                                            ref: null,
	                                            props: {
	                                                children: 'Activities',
	                                                className: _classnames2['default'](_stylesPanelCss2['default']['panel-header'], _stylesPanelCss2['default']['panel-header-light'])
	                                            },
	                                            _owner: null
	                                        },
	                                        className: _classnames2['default'](_stylesPanelCss2['default'].panel, _componentsTimelineItemStylesCss2['default']['timeline-list-item-content-right'])
	                                    },
	                                    _owner: null
	                                }],
	                                className: _classnames2['default'](_stylesContainerCss2['default']['container'], _componentsTimelineItemStylesCss2['default']['timeline-list-item'])
	                            },
	                            _owner: null
	                        }, items.map(function (item, key) {
	                            return {
	                                $$typeof: _typeofReactElement,
	                                type: _componentsTimelineItemTimelineItem2['default'],
	                                key: key,
	                                ref: null,
	                                props: _defaultProps(_componentsTimelineItemTimelineItem2['default'].defaultProps, {
	                                    detail: item
	                                }),
	                                _owner: null
	                            };
	                        })],
	                        className: _stylesCss2['default']['timeline-list']
	                    },
	                    _owner: null
	                }],
	                className: _classnames2['default'](_stylesContainerCss2['default'].container, _stylesCss2['default'].timeline)
	            },
	            _owner: null
	        };
	    };
	
	    return Timeline;
	})(_react2['default'].Component);
	
	;
	
	exports['default'] = Timeline;
	module.exports = exports['default'];

/***/ },

/***/ 141:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactRedux = __webpack_require__(51);
	
	var _componentsHeaderHeader = __webpack_require__(136);
	
	var _componentsHeaderHeader2 = _interopRequireDefault(_componentsHeaderHeader);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var itinerary = state.get('itinerary');
	    var title = itinerary.get('title');
	
	    return {
	        title: title
	    };
	};
	
	var Header = _reactRedux.connect(mapStateToProps)(_componentsHeaderHeader2['default']);
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ },

/***/ 142:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactRedux = __webpack_require__(51);
	
	var _componentsTimelineTimeline = __webpack_require__(140);
	
	var _componentsTimelineTimeline2 = _interopRequireDefault(_componentsTimelineTimeline);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	    var itinerary = state.get('itinerary');
	    var items = itinerary.get('items');
	
	    return {
	        items: items
	    };
	};
	
	var Timeline = _reactRedux.connect(mapStateToProps)(_componentsTimelineTimeline2['default']);
	
	exports['default'] = Timeline;
	module.exports = exports['default'];

/***/ },

/***/ 143:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _immutable = __webpack_require__(88);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _actions = __webpack_require__(78);
	
	var defaultState = _immutable2['default'].fromJS({
	    itinerary: { title: "", items: [] },
	    isLoading: false
	});
	
	var activities = function activities(state, action) {
	    if (state === undefined) state = defaultState;
	
	    switch (action.type) {
	        case _actions.GET_ITINERARY:
	            return state.set('isLoading', true);
	        case _actions.SET_ITINERARY:
	            return state.set('itinerary', action.itinerary).set('isLoading', false);
	        default:
	            return state;
	    }
	};
	
	exports['default'] = activities;
	module.exports = exports['default'];

/***/ },

/***/ 158:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2LmYY"};

/***/ },

/***/ 159:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"app-header":"_1Xr7I"};

/***/ },

/***/ 160:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1HBdY"};

/***/ },

/***/ 161:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2NL8R","map":"x3Es7"};

/***/ },

/***/ 162:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"timeline":"_1FoaP","timeline-vertical-line":"_1W8Rm"};

/***/ },

/***/ 163:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 180:
/***/ function(module, exports) {

	module.exports = [
		{
			"featureType": "all",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#ffffff"
				}
			]
		},
		{
			"featureType": "all",
			"elementType": "labels.text.stroke",
			"stylers": [
				{
					"color": "#000000"
				},
				{
					"lightness": 13
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "administrative",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#144b53"
				},
				{
					"lightness": 14
				},
				{
					"weight": 1.4
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#08304b"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#0c4152"
				},
				{
					"lightness": 5
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#0b434f"
				},
				{
					"lightness": 25
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"color": "#0b3d51"
				},
				{
					"lightness": 16
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#000000"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"color": "#146474"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#0f7abd"
				}
			]
		}
	];

/***/ },

/***/ 320:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ 321:
320

});


/** WEBPACK FOOTER **
 ** app.js
 **/